import { render, staticRenderFns } from "./global-task-create.vue?vue&type=template&id=d2a96376&"
import script from "./global-task-create.vue?vue&type=script&lang=ts&"
export * from "./global-task-create.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports